import styled, { css } from "styled-components";
import Descriptions from "antd/es/descriptions";
import { getNewLookTokens, newLookType } from "common/NewLook/tokens.ts";

const InvitationDescriptions = styled(Descriptions)`
  .ant-descriptions-item-label {
    background-color: ${(p) => p.theme.colors.blues[0]};
    width: 200px;
  }
`;

const ValidationError = styled.span`
  color: #ff4d4f;
  margin-top: 12px;
  display: block;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      margin-top: 8px;
      color: ${getNewLookTokens(p.theme).down};
      ${newLookType.meta};
      font-size: 12.5px;
    `}
`;

export { ValidationError, InvitationDescriptions };
